module.exports = __webpack_public_path__ + "static/media/woman.3964fa4b.png";